<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Transportation Quotation Form</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="d-block text-center">
              <div>
                <b-collapse id="collapseFFMain2" v-model="collapseFFMainVisibleTPT">
                  <div class="box-body">
                    <!-- <div class="box-header">
                  <h5 class="box-title">
                    <u>Existing TPT Quotations</u>
                  </h5>
                  <md-button
                    @click="openTPT"
                    v-if="hideButtn==false"
                    class="md-raised md-primary md-button-color md-theme-default back heght-1px pull-right"
                  >New TPT Quotation</md-button>
                    </div>-->
                    <div class="table-responsive tableMain mt-3">
                      <table id="tpt" class="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sr no</th>
                            <th>TPT Quotation</th>

                            <th>Approval Status</th>

                            <th>Action</th>
                            <th>PDF</th>

                            <!-- <th>Client Name</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item1, index) in tptTableArryMain" :key="index">
                            <td>{{ index + 1 }}</td>

                            <td :style="index == 0 ? 'color:green' : 'color:red'">
                              <b>Quotation No. :</b>
                              {{ item1.tptQSeries }}
                              <br />
                              <b>Validity Date :</b>
                              {{ item1.validityDate | moment }}
                              <br />
                              <span class="error">{{
                                item1.expireStatus == 1 ? " (Expired)" : ""
                              }}</span>

                              <b-button
                                v-if="collapseFFChildVisibleTPT == false"
                                class="gutr"
                                @click="getMainTPTId(item1.tptQId, 'TPT')"
                                variant="outline-primary"
                                size="sm"
                                >Show Quote</b-button
                              >
                            </td>

                            <td>
                              <b>Manager Approval :</b>
                              {{
                                item1.tptStatus == "0"
                                  ? "Pending"
                                  : item1.tptStatus == "1"
                                  ? "Approved"
                                  : "Rejected"
                              }}
                              <br />
                              <b>Client Approval :</b>
                              {{
                                item1.tptClientStatus == "0"
                                  ? "Pending"
                                  : item1.tptClientStatus == "1"
                                  ? "Approved"
                                  : "Rejected"
                              }}
                              <br />
                              <br />
                              <span v-if="item1.tptQuoteRejectCount != '0'" class="error"
                                >Note : Quote Rejected
                                {{ item1.tptQuoteRejectCount }} Times By Client.</span
                              >
                            </td>

                            <!-- <td>{{item1.clientName}}</td> -->
                            <!-- <td>
                      <md-button
                        class="md-icon-button md-raised md-dense"
                        @click="editTPT(item1.tptQId)"
                      >
                        <md-icon>edit</md-icon>
                      </md-button>
                            </td>-->
                            <td
                              v-if="
                                index == '0' &&
                                item1.tptClientStatus != '2' &&
                                item1.tptClientStatus != '1'
                              "
                            >
                              <b
                                v-if="
                                  item1.tptStatus != '1' && item1.sendHODApprove == '1'
                                "
                                >Sent For Approval
                                <br />
                              </b>
                              <!-- <b
                                v-else-if="item1.tptStatus=='1' && item1.sentToEnquiry=='0'"
                                class="showMoreData"
                                @click="openPop(item1)"
                              >Send To Enquiry Team
                                <br>
                              </b>-->
                              <b
                                v-else-if="
                                  item1.tptStatus == '1' && item1.sentToEnquiry == '1'
                                "
                                >Sent to Enquiry Team
                                <br />
                              </b>
                              <b v-else
                                >N/A
                                <br />
                              </b>
                            </td>
                            <td v-else>
                              <b>
                                {{
                                  item1.tptClientStatus == "2" && index == 0
                                    ? "Client Rejected"
                                    : item1.tptClientStatus == "1" && index == 0
                                    ? "Client Approved"
                                    : "N/A"
                                }}
                                <br />
                              </b>
                            </td>
                            <td>
                              <span v-if="item1.MainEnquiryQuotationCreated">{{ item1.MainEnquiryQuotationCreated }}</span><br/>
                              <span v-if="item1.MainEnquiryQuotationUpdated">{{ item1.MainEnquiryQuotationUpdated }}</span><br/>
                              <span v-if="item1.MainEnquiryQuotationTPTApprovedBy">{{ item1.MainEnquiryQuotationTPTApprovedBy }}</span><br/>
                              <md-button
                                v-if="
                                  item1.tptQuotationPdf != '' &&
                                  item1.tptQuotationPdf != null
                                "
                                class="md-icon-button md-raised md-dense"
                                @click="Print(item1.tptQuotationPdf)"
                              >
                                <md-icon>print</md-icon>
                              </md-button>
                              <b v-else>Pdf Not Generated</b>
                              <div v-if="!isHidden">
                                <date-picker
                                  style="margin-top: 8px"
                                  lang="en"
                                  :format="selectDateFormat"
                                  id="validityDate"
                                  name="validityDate"
                                  :not-before="min"
                                  :not-after="max"
                                  v-model="item1.validityDate"
                                ></date-picker>
                                <!-- hide hideMe  -->
                                <span class="error" v-if="!item1.validityDate">{{
                                  errorModal.validityDate
                                }}</span>
                                <!-- hide hideMe  -->

                                <b-button
                                  class="smbutnWidth"
                                  style="margin-top: 8px"
                                  variant="primary"
                                  size="sm"
                                  id="updateValidityDate"
                                  @click="
                                    updateValidityDate(
                                      item1.validityDate,
                                      item1.tptQId,
                                      this.mainTPTtableIdForTPT,
                                      'TPT',
                                      (quotationTill = 0),
                                      (prevalidityDate = item1.validityDate)
                                    )
                                  "
                                  >Update</b-button
                                >
                              </div>

                              <b-button
                                v-if="item1.expireStatus == 1"
                                class="smbutnWidth"
                                style="margin-top: 8px"
                                variant="primary"
                                size="sm"
                                id="QutationValidityhide"
                                @click="
                                  QutationValidityhide(item1.validityDate, isHidden)
                                "
                                >Qutation Extends</b-button
                              >
                              <br /><span id="QutationValidityhide_err"></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- /.box-body -->
                  </div>
                </b-collapse>
              </div>
              <b-collapse id="collapseFFChild2" v-model="collapseFFChildVisibleTPT">
                <div>
                  <div>
                    <div>
                      <div>
                        <b-card class="gutr">
                          <!-- <md-layout md-flex="5"></md-layout>

                            <md-layout md-flex="20">
                              <md-layout md-flex="100">
                                <label for="baseCost">Base Cost (INR)</label>

                                <b-form-input :formatter="capitalizeAll"
                                  id="baseCost"
                                  name="baseCost"
                                  type="number"
                                  v-model="tptModal.baseCost"
                                ></b-form-input>
                                <span
                                  class="error"
                                  v-if="!tptModal.baseCost"
                                >{{errortptModal.baseCost}}</span>
                              </md-layout>
                          </md-layout>-->
                          <!-- <md-layout md-flex="5"></md-layout>
                            <md-layout md-flex="20">
                              <md-layout md-flex="100">
                                <label for="quoRate">Transportation Charges ( INR )</label>
                                <b-form-input :formatter="capitalizeAll"
                                  id="quoRate"
                                  name="quoRate"
                                  type="number"
                                  v-model="tptModal.quotRate"
                                ></b-form-input>
                               
                              </md-layout>
                          </md-layout>-->
                          <b-row>
                            <b-col md="2">
                              <label class="pull-left">Quotation Validity Date *</label>
                              <!-- <date-picker
                                :disabled="mainTPTtableIdForTPT ? true : false"
                                lang="en"
                                :format="selectDateFormat"
                                id="validityDate"
                                name="validityDate"
                                class="w-100"
                                :not-before="new Date()"
                                v-model="tptModal.validityDate"
                              ></date-picker> -->
                              <b-form-input
                                :disabled="mainTPTtableIdForTPT ? true : false"
                                :formatter="capitalizeAll"
                                v-model="tptModal.validityDate"
                                type="date"
                                placeholder="Enter Billing Start Date"
                                :min="calculateMinDate()"
                                :max="calculateMaxDate()"
                                :not-before="new Date()"
                              ></b-form-input>
                              <span class="error" v-if="!tptModal.validityDate">{{
                                errortptModal.validityDate
                              }}</span>
                            </b-col>
                            <b-col md="4">
                              <label class="pull-left" for="quoRate"
                                >Quotation Remarks</label
                              >

                              <b-form-input
                                :formatter="capitalizeAll"
                                id="quoRate"
                                name="quoRate"
                                v-model="tptModal.quotation_remark"
                              ></b-form-input>
                            </b-col>
                            <b-col
                              md="2"
                              v-if="
                                tptModal.tptQId != '' &&
                                tptModal.sendHODApprove == '1' &&
                                this.$sessionsStorage.get('userLevel') == '1'
                              "
                            >
                              <label class="w-100 text-left" for="transportType"
                                >Manager Approval</label
                              >
                              <model-list-select
                                :isDisabled="
                                  tptModal.tptClientStatus == '1' ? true : false
                                "
                                :list="statusList"
                                v-model="tptModal.tptStatus"
                                option-value="statusV"
                                option-text="statusT"
                                placeholder="Select Status"
                              ></model-list-select>
                            </b-col>
                            <b-col
                              md="4"
                              v-if="
                                tptModal.tptQId != '' && tptModal.sendHODApprove == '1'
                              "
                            >
                              <label class="pull-left" for="quoRate"
                                >Remarks if Any</label
                              >

                              <b-form-input
                                :formatter="capitalizeAll"
                                id="quoRate"
                                name="quoRate"
                                v-model="tptModal.remark"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                          <b-row class="mt-2">
                            <b-col md="6">
                              <div
                                style="text-align: left"
                                v-if="tptTableArry.length > 0"
                              >
                                <!-- :disabled="buttonDisable" -->
                                <b-button
                                  class="smbutnWidth"
                                  v-if="
                                    tptModal.tptQId != '' &&
                                    tptModal.sendHODApprove == '1'
                                  "
                                  variant="primary"
                                  size="sm"
                                  id="addButtonLoaderAdd"
                                  @click="addGenerateQuotation('5')"
                                  >{{
                                    tptModal.tptQId == "" ? "Add" : "Update"
                                  }}</b-button
                                >
                                <md-spinner
                                  md-indeterminate
                                  id="loaderAdd"
                                  style="display: none"
                                ></md-spinner>
                                <b-button-group>
                                  <b-button
                                    size="sm"
                                    class="pull-left"
                                    variant="outline-dark"
                                    @click="visibleMTPT = !visibleMTPT"
                                  >
                                    <span v-if="visibleMTPT == true">Close</span>
                                    <span v-else>Add More Particulars</span>
                                  </b-button>
                                </b-button-group>
                              </div>
                            </b-col>
                            <b-col md="6">
                              <b-navbar-nav class="ml-auto pull-right">
                                <div v-if="tptTableArry.length > 0">
                                  <b-button-group>
                                    <b-button
                                      v-if="
                                        tptModal.tptQId != '' &&
                                        tptModal.tptStatus != '1' &&
                                        tptModal.tptClientStatus != '2' &&
                                        tptModal.sendHODApprove != '1'
                                      "
                                      variant="outline-dark"
                                      size="sm"
                                      @click="openPop"
                                      >Send For Approval
                                      <md-icon icon="envelope">email</md-icon>
                                    </b-button>
                                  </b-button-group>
                                </div>
                              </b-navbar-nav>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>
                      <div>
                        <b-collapse
                          id="collapseMiddle"
                          v-model="visibleMTPT"
                          class="mt-2"
                        >
                          <b-card>
                            <b-row>
                              <b-col md="4" style="text-align: left">
                                <label for="distance">Distance (Km)</label>
                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="distance"
                                  name="distance"
                                  type="number"
                                  v-model="tptTableModal.distance"
                                ></b-form-input>
                                <!-- <span
                                    class="error"
                                    v-if="!tptModal.distance"
                                  >{{errortptModal.distance}}</span>-->
                              </b-col>
                              <b-col md="4" style="text-align: left">
                                <label for="dieselRate">Diesel Allocated (Ltrs)</label>
                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="dieselRate"
                                  name="dieselRate"
                                  type="number"
                                  v-model="tptTableModal.dieselAllocated"
                                ></b-form-input>
                              </b-col>
                              <b-col md="4" style="text-align: left">
                                <label for="dieselRate">Diesel Rate (INR)</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="dieselRate"
                                  name="dieselRate"
                                  type="number"
                                  v-model="tptTableModal.dieselRate"
                                ></b-form-input>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col md="4" style="text-align: left">
                                <label for="mileage">Mileage</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="mileage"
                                  name="mileage"
                                  type="number"
                                  v-model="tptTableModal.mileage"
                                ></b-form-input>
                              </b-col>
                              <b-col md="4" style="text-align: left">
                                <label for="toll">Toll (INR)</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="toll"
                                  name="toll"
                                  type="number"
                                  v-model="tptTableModal.toll"
                                ></b-form-input>
                              </b-col>
                              <b-col md="4" style="text-align: left">
                                <label for="margin">Advance Cash (INR)</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="margin"
                                  name="margin"
                                  type="number"
                                  v-model="tptTableModal.advanceCash"
                                ></b-form-input>
                              </b-col>
                            </b-row>
                            <b-row v-if="tptModal.shipmentType == '1'">
                              <!-- <b-row v-if="tptModal.shipmentType == '1' && tptModal.transportType!='Domestic'"> -->
                              <b-col md="4" style="text-align: left">
                                <label for="transportType">Container Type *</label>
                                <model-list-select
                                  :list="containerTypeList"
                                  v-model="tptTableModal.containerTypeId"
                                  option-value="containerTypeId"
                                  option-text="containerType"
                                  placeholder="Select Type"
                                ></model-list-select>
                                <span
                                  class="error"
                                  v-if="!tptTableModal.containerTypeId"
                                  >{{ blankConTypeError }}</span
                                >
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col
                                md="4"
                                style="text-align: left"
                                v-if="tptTableModal.tptTableId == ''"
                              >
                                <label for="transportType">Particulars *</label>
                                <model-list-select 
                                      :list="$store.getters['common/getAllLedgerList']" 
                                      v-model="tptTableModal.ledgerId"
                                      option-value="ledgerId" 
                                      option-text="ledger" 
                                      @input="getPartiName"
                                      placeholder="Select Particular">
                                      </model-list-select>
                                <!-- <model-list-select
                                  :list="ledgerData"
                                  v-model="tptTableModal.ledgerId"
                                  option-value="ledgerId"
                                  option-text="ledger"
                                  @input="getPartiName"
                                  id="other"
                                  placeholder="Select Particulars"
                                ></model-list-select> -->
                                <span class="error" v-if="!tptTableModal.ledgerId">{{
                                  errortptTableModal.ledgerId
                                }}</span>
                              </b-col>
                              <b-col md="4" style="text-align: left" v-else>
                                <label for="transportType">Particulars</label>
                                <model-list-select
                                  isDisabled
                                  :list="ledgerData"
                                  v-model="tptTableModal.otherCharge"
                                  option-value="ledger"
                                  option-text="ledger"
                                  placeholder="Select Particulars"
                                ></model-list-select>
                              </b-col>
                              <b-col
                                md="2"
                                style="text-align: left"
                                v-if="particularStatus == '0'"
                              >
                                <label for="sellingRate">Buy In Rate *</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="sellingRate"
                                  name="sellingRate"
                                  type="number"
                                  v-model="tptTableModal.byInPrice"
                                ></b-form-input>
                                <span class="error" v-if="!tptTableModal.byInPrice">{{
                                  blankbuyinError
                                }}</span>
                              </b-col>
                              <b-col
                                md="2"
                                style="text-align: left"
                                v-if="particularStatus == '0'"
                              >
                                <label for="buyingRate">Selling Rate *</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="buyingRate"
                                  name="buyingRate"
                                  type="number"
                                  v-model="tptTableModal.qRate"
                                ></b-form-input>
                                <span class="error" v-if="!tptTableModal.qRate">{{
                                  blankSellingError
                                }}</span>
                              </b-col>
                              <b-col
                                md="2"
                                style="text-align: left"
                                v-if="particularStatus == '0'"
                              >
                                <label for="transportType">Currency *</label>
                                <model-list-select
                                  :list="currencyList"
                                  v-model="tptTableModal.currency"
                                  option-value="currencyV"
                                  option-text="currencyT"
                                  placeholder="Select"
                                ></model-list-select>
                                <span class="error" v-if="!tptTableModal.currency">{{
                                  blankcurrencyError
                                }}</span>
                              </b-col>
                              <b-col
                                md="2"
                                style="text-align: left"
                                v-if="particularStatus == '0'"
                              >
                                <label for="transportType">Units *</label>
                                <model-list-select
                                  :list="unitList"
                                  v-model="tptTableModal.unit"
                                  option-value="unitId"
                                  option-text="unitName"
                                  placeholder="Select"
                                ></model-list-select>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col md="12">
                                <b-form-checkbox
                                  id="checkbox-1"
                                  class="pull-left"
                                  v-model="particularStatus"
                                  name="checkbox-1"
                                  value="1"
                                  unchecked-value="0"
                                  >Charges As Per Receipt</b-form-checkbox
                                >
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col md="4" style="text-align: left">
                                <label for="transportType">Terms</label>
                                <model-list-select
                                  :list="termList"
                                  v-model="tptTableModal.terms"
                                  option-value="tV"
                                  option-text="tT"
                                  placeholder="Select"
                                ></model-list-select>
                              </b-col>
                              <b-col md="4" style="text-align: left">
                                <label for="freeDays">Free Days</label>
                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="freeDays"
                                  name="freeDays"
                                  type="number"
                                  v-model="tptTableModal.freeDays"
                                ></b-form-input>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col md="12" style="text-align: left">
                                <label for="sellingRate">Special Remarks</label>
                                <b-form-textarea
                                  :formatter="capitalizeAll"
                                  id="sellingRate"
                                  name="sellingRate"
                                  v-model="tptTableModal.line_wise_remark"
                                ></b-form-textarea>
                              </b-col>
                            </b-row>
                            <b-row class="mt-4">
                              <b-col md="12">
                                <b-button
                                  size="sm"
                                  class="smbutnWidth"
                                  variant="primary"
                                  id="addButtonLoaderOth"
                                  @click="addGenerateQuotation('1')"
                                  :disabled="
                                    $sessionsStorage.get('designation') == 'Admin' &&
                                    $sessionsStorage.get('nameUser') == 'Bhavneesh'
                                      ? false
                                      : buttonDisable
                                  "
                                  >{{
                                    tptTableModal.tptTableId == "" ? "Add" : "Update"
                                  }}</b-button
                                >
                                <md-spinner
                                  md-indeterminate
                                  id="loaderOth"
                                  style="display: none"
                                ></md-spinner>
                              </b-col>

                              <b-col lg="12">
                                <span
                                  class="error pull-right"
                                  v-if="tptTableModal.MainEnquiryQuotationCreated"
                                >
                                  <b> {{ tptTableModal.MainEnquiryQuotationCreated }}</b>
                                </span>
                              </b-col>

                              <b-col lg="12">
                                <span
                                  class="error pull-right"
                                  v-if="tptTableModal.MainEnquiryQuotationUpdated"
                                >
                                  <b> {{ tptTableModal.MainEnquiryQuotationUpdated }}</b>
                                </span>
                              </b-col>

                              <!-- <b-col lg="12"> {{ tptTableModal }} </b-col> -->
                            </b-row>
                          </b-card>
                        </b-collapse>
                      </div>
                    </div>

                    <!-- /.box-header  -->
                    <div class="box-body" v-if="tptTableArry.length > 0">
                      <div>
                        <div class="box-header"></div>
                        <div class="table-responsive tableMain">
                          <table id="tpt" class="table table-bordered">
                            <thead>
                              <tr>
                                <th>Sr no</th>
                                <th v-if="tptModal.shipmentType == '1'">
                                  <!-- <th v-if="tptModal.shipmentType == '1' && tptModal.transportType!='Domestic'"> -->
                                  Container Type
                                </th>
                                <th>Particulars</th>

                                <th>Buy In Rate</th>
                                <th>Selling Rate</th>
                                <th>Unit</th>

                                <!-- <th>Remarks</th> -->
                                <th>Special Remarks</th>

                                <th>Edit</th>
                                <th>Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item1, index) in tptTableArry" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td v-if="tptModal.shipmentType == '1'">
                                  <!-- <td v-if="tptModal.shipmentType == '1' && tptModal.transportType!='Domestic'"> -->
                                  {{ item1.containerType }}
                                </td>
                                <td>{{ item1.otherCharge }}</td>
                                <td>{{ item1.byInPrice }} {{ item1.currency }}</td>
                                <td>{{ item1.qRate }} {{ item1.currency }}</td>
                                <td>
                                  {{ item1.unitName ? item1.unitName : "NA" }}
                                </td>

                                <!-- <td>{{ item1.remark }}</td> -->
                                <td>{{ item1.line_wise_remark }}</td>

                                <!-- <td>{{item1.clientName}}</td> -->
                                <td>
                                  <md-button
                                    class="md-icon-button md-raised md-dense"
                                    @click="editTPT(item1)"
                                  >
                                    <md-icon>edit</md-icon>
                                  </md-button>
                                </td>
                                <td>
                                  <md-button
                                    class="md-icon-button md-raised md-dense"
                                    @click="deleteTPT(item1)"
                                  >
                                    <md-icon>delete</md-icon>
                                  </md-button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <!-- /.box-body -->
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <!-- <md-dialog-confirm
      :md-title="confirm.content"
      :md-content-html="confirm.content"
      :md-Send-text="confirm.ok"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>-->
    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>
    <md-snackbar
      :md-position="vertical + ' ' + horizontal"
      ref="snackbar"
      :md-duration="duration"
    >
      <span>{{ snackbarData }}</span>
    </md-snackbar>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="popMailAfter"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import { ModelListSelect } from "vue-search-select";

import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";
import transportation from "../../sidebar/transportation.js";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllLedgerList",
      JSON.stringify({
        itemCode: "LedgerList",
        JobType:this.$route.query.JobType,
        ShipmentType:this.$route.query.ShipmentType,
        ModuleType:this.$route.query.ModuleType,
        isLedgerActive:'1',
      })
    );
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewConsoBooking");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      errorModal: {
        validityDate: "",
      },
      arrayErrorModal: {
        validityDate: "Select Date",
      },
      prevalidityDate: "",
      isHidden: true,
      max: "",
      min: "",
      selectDateFormat,
      confirm: {
        title: "Confirmation..!",
        contentHtml: "Data",
        ok: "Send",
        cancel: "Cancel",
      },
      vertical: "bottom",
      horizontal: "center",
      duration: 1700,
      snackbarData: "",
      blankConTypeError: "",
      blankbuyinError: "",
      blankSellingError: "",
      blankcurrencyError: "",
      particularStatus: "0",
      visibleMTPT: true,
      isLoading: "",
      docURL: URL_BASE_DOC,
      openTPTDiv: false,
      openFFDiv: false,
      openCCDiv: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      collapseFFMainVisibleTPT: false,

      collapseFFChildVisibleTPT: false,
      tptModal: {
        tptqCreatedDate: "",
        tptvalidTill: "",
        shipmentType: "",
        transportation:"",
        baseCosting: "",
        dieselAllocated: "",
        tptQId: "",
        tptQSeries: "",
        advanceCash: "",
        mainEnquiryId: "",
        enquiryClientId: "",
        driverExp: "",
        travelDur: "",
        distance: "",
        toll: "",
        mileage: "",
        dieselRate: "",
        margin: "",
        baseCost: "0",
        quotRate: "",
        tptStatus: "",
        tptClientStatus: "",
        sendHODApprove: "",
        remark: "",
        validityDate: "",
        quotation_remark: "",
        expireStatus: "",
      },
      errortptModal: {
        // advanceCash: "",
        // // driverExp: "",
        // //  travelDur: "",
        // distance: "",
        // toll: "",
        // mileage: "",
        //dieselRate: "",
        // margin: "",
        // baseCost: "",
        // quotRate: "",

        validityDate: "",
      },
      arrayErrortptModal: {
        // driverExp: "Enter Driver Expense",
        // travelDur: "Enter Travel Duration",
        // distance: "Enter Distance",
        // toll: "Enter Toll",
        // mileage: "Enter Mileage",
        //  dieselRate: "Enter Diesel Rate",
        //  margin: "Enter Margin",
        // baseCost: "Enter Base Cost",
        // quotRate: "Enter Qutotation Rate",

        validityDate: "Select Date",
      },
      containerTypeList: [],
      sortConArry: [],
      ENQHODMAIL: [],
      ledgerData: [],
      tptTableModal: {
        unit: "",
        terms: "Collect",
        advanceCash: "",
        toll: "",
        mileage: "",
        dieselRate: "",
        dieselAllocated: "",
        distance: "",
        containerTypeId: "",
        tptTableId: "",
        mainEnquiryId: "",
        tptQId: "",
        ledgerId: "",
        otherCharge: "",
        qRate: "",
        byInPrice: "",
        remark: "",
        line_wise_remark: "",
        currency: "INR",
        freeDays: "",
        MainEnquiryQuotationCreated: "",
        MainEnquiryQuotationUpdated: "",
      },
      errortptTableModal: {
        ledgerId: "",
      },
      arrayErrortptTableModal: {
        ledgerId: "Select Particulars",
      },
      ffModal: {
        mainEnquiryId: "",
        ffQId: "",
        enquiryClientId: "",
        ffType: "",
        buyingRate: "",
        ffSellingRate: "",
        shippingId: "",
        enquiryClientId: "",
        ffStatus: "",
        ffClientStatus: "",
      },
      ccModal: {
        mainEnquiryId: "",
        enquiryClientId: "",
        ccQId: "",
        ccType: "",
        ccSellingRate: "",
        ccStatus: "",
        ccClientStatus: "",
      },
      mailModal: {
        mainEnquiryId: "",
        tptQId: "",
      },
      ffTypeList: [
        // {
        //   ffTypeVal: "FreeDays",
        //   ffTypeText: "FREE DAYS"
        // },
        // {
        //   ffTypeVal: "TPTCharges",
        //   ffTypeText: "Transportation Charges"
        // },
        {
          ffTypeVal: "DetentionCharges",
          ffTypeText: "Detention Charges",
        },
        {
          ffTypeVal: "TollCharges",
          ffTypeText: "Toll Charges",
        },
        {
          ffTypeVal: "WeighmentCharges",
          ffTypeText: "Weighment Charges",
        },
        {
          ffTypeVal: "OverloadCharges",
          ffTypeText: "Overload Charges",
        },
        {
          ffTypeVal: "ECCTAX_GREEN TAX",
          ffTypeText: "ECC TAX / GREEN TAX",
        },
        {
          ffTypeVal: "OffloadingCharges",
          ffTypeText: "Offloading Charges",
        },
        // {
        //   ffTypeVal: "Other",
        //   ffTypeText: "Other"
        // }
      ],
      ccList: [
        {
          ccTypeVal: "CC_Charges",
          ccTypeText: "Custom Clearance Charges",
        },
        {
          ccTypeVal: "LH_Charges",
          ccTypeText: "Local Handling Charges",
        },
      ],
      termList: [
        {
          tV: "Collect",
          tT: "Collect",
        },
        {
          tV: "Prepaid",
          tT: "Prepaid",
        },
      ],
      unitList: [],
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],
      statusList: [
        // {
        //   statusV: "0",
        //   statusT: "In Progress"
        // },
        {
          statusV: "1",
          statusT: "Approve",
        },
        {
          statusV: "2",
          statusT: "Reject",
        },
      ],
      newData: {
        tptQId: "",
        mainEnquiryId: "",
        tptQSeries: "",
        tptQuotationPdf: "",
      },

      checkModule: [],
      enquiryArry: [],
      tptTableArry: [],
      tptTableArryMain: [],
      ffTableArry: [],
      ccTableArry: [],
      shippingList: [],
      tempffTableArry: [],
      ffShipArry: [],
      mainTPTtableIdForTPT: "",
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },

  computed: {
    buttonDisable() {
      return this.tptModal.sendHODApprove == "1" ? true : false;
    },
  },

  methods: {
    getPartiName() {
      let Arry = this.ledgerData.filter((x) => {
        return x.ledgerId == this.tptTableModal.ledgerId;
      });
      if (Arry.length > 0) {
        this.tptTableModal.otherCharge = Arry[0].ledger;
      } else {
        this.tptTableModal.otherCharge = "";
      }
    },
    Print(item) {
      if(!item) return;
      this.openSignedDocument(`TPT_QUOTATION_PDF/${item}`);
    },
    getMainTPTId(MAINTPTID) {
      this.mainTPTtableIdForTPT = MAINTPTID;

      this.getData();
      this.collapseFFChildVisibleTPT = true;
      // this.visibleMTPT = false;
    },

    sendMailEnq() {
      this.newData["jobType"] = "TPT";
      console.log(this.newData);

      this.isLoading = true;
      if (this.validate != false) {
        // $("#addButtonLoaderS").css("display", "none");
        // $("#loaderS").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/sendForClientTPT_VP.php`,
          data: JSON.stringify(this.newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            // $("#loaderS").css("display", "none");
            // $("#addButtonLoaderS").css("display", "block");
            this.isLoading = false;
            // this.getData();
            // this.$router.push({
            //   path: "/mainEnquiry/viewMainEnqQuotationTPT"
            // });
          })
          .catch((error) => {});
      }
    },

    // deleteTPT(item) {
    //   let paylod = {
    //     tableName: "maintptqtable",
    //     tableId: "tptTableId",
    //     tableVal: item.tptTableId,
    //   };

    //   let options = {
    //     method: "POST",
    //     url: `${URL_BASE}/Enquiry/deletePermanent.php`,
    //     data: JSON.stringify(paylod),
    //     crossDomain: true,
    //     headers: {
    //       Accept: "application/json",
    //       "Content-Type": "application/json",
    //       Authorization: this.$sessionsStorage.get("loginId"),
    //     },
    //   };
    //   axios(options)
    //     .then((result) => {
    //       const { statusText, status, data } = result;
    //       if (status == 200 && data) {
    //         this.getData();
    //       }
    //     })
    //     .catch((error) => {});
    // },
    deleteTPT(item) {
      this.itemObj = item;
      this.itemObj.is_active = item.is_active == "1" ? 0 : 1;
      let payload = {
        tableName: "maintptqtable",
        tableId: "tptTableId",
        tableIsActive: "is_active",
        value1: this.itemObj.is_active,
        tableVal: item.tptTableId,
        isMailSend: "No",
        manual: "No",
      };
      //console.log("Payload => ", payload); return false;
      ClientUserService.getAllActive(JSON.stringify(payload))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on getAllActive Error: ", error);
        });
    },
    openTPT() {
      this.openTPTDiv = true;
    },
    openFF() {
      this.openFFDiv = true;
    },
    openCC() {
      this.openCCDiv = true;
    },

    finalbasecost() {
      let driverExpensenew =
        parseFloat(this.tptModal.driverExp) * parseFloat(this.tptModal.travelDur);

      let averageTrucknew =
        parseFloat(this.tptModal.distance) / parseFloat(this.tptModal.mileage);

      let dieselRatenew =
        parseFloat(averageTrucknew) * parseFloat(this.tptModal.dieselRate);
      let basefinalcost =
        parseFloat(dieselRatenew) +
        parseFloat(driverExpensenew) +
        parseFloat(this.tptModal.toll);
      this.tptModal.baseCost = basefinalcost.toFixed(2);

      let finalSalesCost =
        (parseFloat(this.tptModal.baseCost) * parseFloat(this.tptModal.margin)) / 100;
      let finalSalesCost2 = finalSalesCost + parseFloat(this.tptModal.baseCost);
      this.tptModal.quotRate = finalSalesCost2.toFixed(2);
    },
    validateTPTQuotation(ID) {
      let validateNew = true;
      if (ID == "1") {
        Object.keys(this.errortptModal).map((x) => {
          if (this.tptModal[x] == "") {
            this.errortptModal[x] = this.arrayErrortptModal[x] || "";
            validateNew = false;
          } else {
            this.errortptModal[x] = "";
          }
        });
      }

      if (ID == "1") {
        if (
          this.tptTableModal.containerTypeId == "" &&
          this.tptModal.shipmentType == "1"
          //  &&
          // this.tptModal.transportType!='Domestic'
        ) {
          this.blankConTypeError = " Select Container Type";
          validateNew = false;
        } else {
          this.blankConTypeError = "";
        }
        if (this.particularStatus == "0") {
          if (this.tptTableModal.byInPrice == "") {
            this.blankbuyinError = "Enter Buying Rate";
            validateNew = false;
          } else {
            this.blankbuyinError = "";
          }
          if (this.tptTableModal.qRate == "") {
            this.blankSellingError = "Enter Selling Rate";
            validateNew = false;
          } else {
            this.blankSellingError = "";
          }
          if (this.tptTableModal.currency == "") {
            this.blankcurrencyError = " Select Currency";
            validateNew = false;
          } else {
            this.blankcurrencyError = "";
          }
        }
        Object.keys(this.errortptTableModal).map((x) => {
          if (this.tptTableModal[x] == "") {
            this.errortptTableModal[x] = this.arrayErrortptTableModal[x] || "";
            validateNew = false;
          } else {
            this.errortptTableModal[x] = "";
          }
        });
      }

      if (validateNew) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addGenerateQuotation(ID) {
      if (this.particularStatus == 1) {
        this.tptTableModal.byInPrice = "Charges As Per Receipt";
        this.tptTableModal.qRate = "Charges As Per Receipt";
        this.tptTableModal.currency = "";
      }
      // this.validateFFExport();

      this.tptModal["mainEnquiryId"] = this.$sessionsStorage.get("editMainEnqId");
      this.tptTableModal["mainEnquiryId"] = this.$sessionsStorage.get("editMainEnqId");

      //  this.tptModal["tptQId"] = this.$sessionsStorage.get("editTPTQId");
      this.tptTableModal["tptQId"] = this.tptModal.tptQId;

      let newData = {
        TPTModal: this.tptModal,
        mainModal: this.tptTableModal,
        buttonId: ID,
      };
      // console.log(newData);
      // return false
      this.validateTPTQuotation(ID);

      if (this.validate != false) {
        // if (ID == "5") {
        //   $("#addButtonLoaderAdd").css("display", "none");
        //   $("#loaderAdd").css("display", "block");
        // }
        // if (ID == "1") {
        //   $("#addButtonLoaderOth").css("display", "none");
        //   $("#loaderOth").css("display", "block");
        // }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainTPTQuotation.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            this.mainTPTtableIdForTPT = data.tptQId;
            this.tptModal.tptQId = data.tptQId;

            if (newData.ID == "5") {
              // $("#loaderAdd").css("display", "none");
              // $("#addButtonLoaderAdd").css("display", "block");
            }

            if (ID == "1") {
              // $("#loaderOth").css("display", "none");
              // $("#addButtonLoaderOth").css("display", "block");
              this.collapseFFChildVisibleTPT = true;
              this.tptTableModal.qRate = "";
              // this.ledgerData = [];
              this.tptTableModal.byInPrice = "";
              this.tptTableModal.otherCharge = "";
              this.tptTableModal.line_wise_remark = "";
              this.tptTableModal.ledgerId = "";
              this.tptTableModal.tptTableId = "";

              this.tptTableModal.MainEnquiryQuotationCreated = "";
              this.tptTableModal.MainEnquiryQuotationUpdated = "";

              // document.getElementById(
              //   "data-v-3a0c7bea data-vss-custom-attr"
              // ).className = "text default";
              this.tptTableModal.dieselAllocated = "";
              this.tptTableModal.toll = "";
              this.tptTableModal.mileage = "";
              this.particularStatus = "0";

              // Object.keys(this.tptTableModal).map(x => {
              //   this.tptTableModal[x] = "";
              // });
            }

            this.snackbarData = "Data Submitted Succesfully";

            this.$refs.snackbar.open();
            this.getData();
          })
          .catch((error) => {});
      }
    },

    openPop() {
      if (this.tptModal.validityDate == "") {
        return false;
      }
      if (this.tptModal.shipmentType == "1" 
      // && this.tptModal.transportType!='Domestic'
    ) {
        let sameConType = [];
        this.containerTypeList.map((x) => {
          let sameCon = this.tptTableArry.filter((y) => {
            return (
              y.containerTypeId == x.containerTypeId && y.containerType == x.containerType
            );
          });
          if (sameCon.length > 0) {
            sameConType.push(sameCon);
          }
        });

        if (sameConType.length != this.containerTypeList.length) {
          this.confirm.contentHtml =
            "<h5 class='error'>INCOMPLETE QUOTE</h5>All Containers Type Requested are not added yet in this Quotation.<br> Send Incomplete Quote for Approval..?";
        } else {
          this.confirm.contentHtml = "Send  Quote for Approval..?";
        }
      } else {
        this.confirm.contentHtml = "Send  Quote for Approval..?";
      }

      this.$refs["popMail"].open();
    },
    sendMail(type) {
      let listTPT = [];
      if (this.tptModal.shipmentType == "1" 
      // && this.tptModal.transportType!='Domestic'
    ) {
        this.tptTableArry = [];

        for (let s = 0; s < this.containerTypeList.length; s++) {
          let arrySort = this.sortConArry.filter((x) => {
            return x.containerType == this.containerTypeList[s].containerType;
          });

          if (arrySort.length > 0) {
            listTPT.splice(s, 0, arrySort);
            this.tptTableArry.push(...arrySort);
          } else {
            console.log("container not in Quote");
          }
        }
      }
      let list = [];
      let list2 = [];
      if (this.tempffTableArry.length > 0) {
        this.tempffTableArry.map((x) => {
          let i = list.indexOf(x.ffType + x.containerType);
          if (i < 0) {
            list.push(x.ffType + "<br>" + x.containerType);
          }
        });

        let unique = list.filter((item, i, ar) => ar.indexOf(item) === i);

        let newList = [];

        unique.map((x) => {
          let obj = {
            type: x,
          };
          console.log(x, obj);

          this.ffShipArry.map((y, index) => {
            let array1 = this.tempffTableArry.filter((z) => {
              return (
                z.ffShippingWiseId == y.ffShippingWiseId &&
                z.ffType + "<br>" + z.containerType == x
              );
            });

            if (array1.length > 0) {
              obj["s" + (index + 1)] = array1[0].ffSellingRate;
              obj["b" + (index + 1)] = array1[0].buyingRate;
              obj["conType"] = array1[0].containerType;
              obj["currency" + (index + 1)] = array1[0].currency;
            } else {
              obj["s" + (index + 1)] = "-";
              obj["b" + (index + 1)] = "-";
              obj["conType"] = "";
              obj["currency" + (index + 1)] = "";
            }
          });

          newList.push(obj);
        });
        if (this.tptModal.shipmentType == "1" 
        // && this.tptModal.transportType!='Domestic'
      ) {
          for (let p = 0; p < this.containerTypeList.length; p++) {
            let arrySort1 = newList.filter((x) => {
              return x.type.split("<br>")[1] == this.containerTypeList[p].containerType;
            });

            if (arrySort1.length > 0) {
              list2.splice(p, 0, arrySort1);
            } else {
              console.log("container not in Quote");
            }
          }
        }
      }
      if (type != "cancel") {
        this.isLoading = true;

        let newData = {
          tptQId: this.mainTPTtableIdForTPT,
          mainEnquiryId: this.$sessionsStorage.get("editMainEnqId"),
          qSeries: this.tptModal.tptQSeries,
          jobType: "TPT",
          MainTPTQ: this.tptModal,
          MainTPTTableQ: this.tptModal.shipmentType == "1" ? listTPT : this.tptTableArry,
          // MainTPTTableQ: this.tptModal.shipmentType == "1" && this.tptModal.transportType!='Domestic' ? listTPT : this.tptTableArry,
          MainFFShip: this.ffShipArry,
          table: list2,
          MainEnq: this.enquiryArry[0],
          hodMails: this.ENQHODMAIL,
          validityDate: this.tptModal.validityDate,
        };

        if (this.validate != false) {
          $("#addButtonLoaderS").css("display", "none");
          $("#loaderS").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Enquiry/sendForApprovalTPT_VP.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");

              this.snackbarData = "Mail Sent For Approval";

              this.$refs.snackbar.open();
              this.getData();
              this.isLoading = false;
            })
            .catch((error) => {});
        }
      }
    },
    previousFFView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/mainEnquiry/viewMainEnqQuotationTPT"
      // });
    },

    // JqueryFun() {
    //   return $(function() {
    //     $("#tpt").DataTable();
    //     $("#ff").DataTable();
    //     $("#cc").DataTable();
    //   });
    // },

    editTPT(item) {
      Object.keys(this.tptTableModal).map((x) => {
        this.tptTableModal[x] = item[x];
      });
      this.visibleMTPT = true;
    },
    editFF(item) {
      Object.keys(this.ffModal).map((x) => {
        this.ffModal[x] = item[x];
      });
      this.openFFDiv = true;
    },
    editCC(item) {
      Object.keys(this.ccModal).map((x) => {
        this.ccModal[x] = item[x];
      });
      this.openCCDiv = true;
    },

    getData() {
      this.isLoading = true;
      let payload = {
        assignmentNo: "assignmentNo",
        fetchFor: "TPT",
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
          this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : "",
        tptQId:
          this.mainTPTtableIdForTPT != "" || this.mainTPTtableIdForTPT != undefined
            ? this.mainTPTtableIdForTPT
            : "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getDataMainQuot.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.enquiryData.length > 0) {
              this.enquiryArry = data.enquiryData;
              this.tptModal.enquiryClientId = data.enquiryData[0].clientId;
              this.tptModal.shipmentType = data.enquiryData[0].shipmentType;
              this.tptModal.transportType=data.enquiryData[0].transportType;
              this.checkModule = data.enquiryData[0].jobType.split(",");
            } else {
              this.enquiryArry = [];
            }
            if (data.unitList.length > 0) {
              this.unitList = data.unitList;
            } else {
              this.unitList = [];
            }

            if (data.containerMaster.length > 0) {
              this.containerTypeList = data.containerMaster;
            } else {
              this.containerTypeList = [];
            }

            if (data.ENQHODMAIL.length > 0) {
              this.ENQHODMAIL = data.ENQHODMAIL;
            } else {
              this.ENQHODMAIL = [];
            }

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }
            if (data.tptData.length > 0) {
              this.tptModal.tptqCreatedDate = data.tptData[0].tptqCreatedDate;
              this.tptModal.tptvalidTill = data.tptData[0].tptvalidTill;
              this.tptTableArryMain = data.tptData;
              this.collapseFFMainVisibleTPT = true;
              this.visibleMTPT = true;
              let arryStatus = this.tptTableArryMain.filter((x) => {
                return (
                  x.tptStatus == "1" && x.tptClientStatus != "2" && x.sentToEnquiry != 1
                );
              });

              if (arryStatus.length > 0) {
                this.newData.tptQId = arryStatus[0].tptQId;
                this.newData.mainEnquiryId = arryStatus[0].mainEnquiryId;
                this.newData.tptQSeries = arryStatus[0].tptQSeries;
                this.newData.tptQuotationPdf = arryStatus[0].tptQuotationPdf;
                this.sendMailEnq();
              }

              // let arryStatus = this.tptTableArry.filter(x => {
              //   return x.tptClientStatus == "1";
              // });

              // if (arryStatus.length > 0) {
              //   this.hideButtn = true;
              // }

              // let arryExpire = this.tptTableArry.filter(x => {
              //   return x.expireStatus == "0" || x.tptClientStatus == "2";
              // });

              // if (arryExpire.length > 0) {

              //   this.hideButtn = false;
              // }
            } else {
              this.tptTableArryMain = [];

              this.collapseFFChildVisibleTPT = true;
            }
            // TPT

            if (data.tptMain.length > 0) {
              Object.keys(data.tptMain[0]).map((x) => {
                this.tptModal[x] = data.tptMain[0][x] || "";
              });
            } else {
              this.tptModal.distance = data.distancegps;
            }
            if (data.tptTableData.length > 0) {
              this.tptTableArry = data.tptTableData;
              this.sortConArry = data.tptTableData;
            } else {
              this.tptTableArry = [];
            }
            if (data.fflastData.length > 0) {
              this.tempffTableArry = data.fflastData;
            }
            if (data.ffShipData.length > 0) {
              this.ffShipArry = data.ffShipData;
            } else {
              this.ffShipArry = [];
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    // By Priyanshu Singh 24/12/2021 Start
    dateDifference(pre_validityDate, current_date) {
      let date1 = new Date(pre_validityDate); //7/13/2010
      let date2 = new Date(current_date); //12/15/2010

      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    currentDate() {
      var currentDate = new Date();
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      return currentDateWithFormat;
    },
    convert(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    },
    dateRestriction(pre_validityDate) {
      const today = new Date(pre_validityDate);
      const minDate = new Date(today);
      // minDate.setMonth(minDate.getMonth()); // one Months
      // minDate.setDate(dateNo);
      const maxDate = new Date(today);
      // maxDate.setMonth(maxDate.getMonth() + 1); // one Months
      this.min = minDate;
      // this.max = maxDate;
      // alert(getDate);
      // alert(minDate);
      // alert(maxDate);
    },
    QutationValidityhide(pre_validityDate, isHidden) {
      this.dateRestriction(pre_validityDate);
      $("#QutationValidityhide_err").text("");
      let current_date = this.currentDate();
      // current_date = '2022-08-04';
      let date1 = new Date(pre_validityDate); //7/13/2010
      let date2 = new Date(current_date); //12/15/2010
      let days_count = 0;
      if (date2 >= date1) {
        days_count = this.dateDifference(pre_validityDate, current_date);
      } else {
        days_count = 0;
      }
      // alert(days_count);
      // let days_count = 46;
      if (
        this.$sessionsStorage.get("designation") != "Admin" &&
        this.$sessionsStorage.get("nameUser") != "Bhavneesh"
      ) {
        if (days_count > 45) {
          this.isHidden = true;
          this.errorModal.validityDate =
            "Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed";
          $("#QutationValidityhide_err").text(
            "Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed"
          );
          // console.log("Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed");
        } else {
          if (isHidden == false) {
            this.isHidden = true;
          } else if (isHidden == true) {
            this.isHidden = false;
          } else {
            this.isHidden = false;
          }
        }
      } else {
        if (isHidden == false) {
          this.isHidden = true;
        } else if (isHidden == true) {
          this.isHidden = false;
        } else {
          this.isHidden = false;
        }
      }
    },
    updateValidityDate(validityDate, tptQId, maintptId, quot_type, pre_validityDate) {
      console.log("validityDate=>", validityDate);
      console.log("tptQId=>", tptQId);
      console.log("maintptId=>", maintptId);
      console.log("quot_type=>", quot_type);
      console.log("pre_validityDate=>", pre_validityDate);
      let current_date = this.currentDate();
      let days_count = this.dateDifference(pre_validityDate, current_date);
      Object.keys(this.errorModal).map((x) => {
        if (this.ffModal[x] == "") {
          this.errorModal[x] = this.arrayErrorModal[x] || "";
          validateNew = false;
        } else {
          this.errorModal[x] = "";
        }
      });
      if (this.validateNew != false) {
        let paylod = {
          tableName: "maintptquotation",
          fk_quot_id: tptQId, //this.$sessionsStorage.get("editTPTQId") maintptId this.ffModal.tptQId
          fk_mainEnquiryId: this.$sessionsStorage.get("editMainEnqId"),
          validityDate: this.convert(validityDate),
          quot_type: quot_type,
          pre_validityDate: pre_validityDate,
        };
        // console.log(paylod);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/AddValidityDateTrack.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            console.log(result);
            console.log("priyanshu");
            if (status == 200 && data) {
              if (data.status == false) {
                $("#QutationValidityhide_err").text(data.msg);
              } else if (data.status == true) {
                this.QutationValidityhide(this.convert(validityDate), false);
                this.getData();
              }
            } else if (status && data) {
            }
          })
          .catch((error) => {});
      }
    }, // By Priyanshu Singh 24/12/2021 End

    calculateMinDateBak() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      let minDate;

      // If the current date is before April 1st, set minDate to April 1st of the previous year
      if (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
        minDate = new Date(currentYear - 1, 3, 1);
      } else {
        // Otherwise, set minDate to April 1st of the current year
        minDate = new Date(currentYear, 3, 1);
      }

      return minDate.toISOString().split('T')[0];
    },
    calculateMaxDateBak() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      let maxDate;

      // If the current date is before April 1st, set maxDate to March 31st of the current year
      if (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
        maxDate = new Date(currentYear, 2, 31);
      } else {
        // Otherwise, set maxDate to March 31st of the next year
        maxDate = new Date(currentYear + 1, 2, 31);
      }

      return maxDate.toISOString().split('T')[0];
    },

    calculateMinDate() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      let minDate;

      // Determine the start of the financial year
      if (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
        minDate = new Date(currentYear - 1, 3, 1);
      } else {
        minDate = new Date(currentYear, 3, 1);
      }

      // Ensure the minimum date is today if today is within the financial year
      if (currentDate > minDate) {
        minDate = currentDate;
      }

      return minDate.toISOString().split('T')[0];
    },
    calculateMaxDate() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      let maxDate;

      // Determine the end of the financial year
      if (currentDate.getMonth() < 3 || (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
        maxDate = new Date(currentYear, 2, 32);
      } else {
        maxDate = new Date(currentYear + 1, 2, 32);
      }

      return maxDate.toISOString().split('T')[0];
    }
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// mainEnqQuotation.vue?6f702ae9